<template>
  <footer
    class="executive-aurora-footer"
    role="contentinfo"
  >
    <!-- Top Animated Energy Light Sweep Accent Line -->
    <div
      class="footer-top-accent"
      aria-hidden="true"
    />

    <!-- Subtle Ambient Radial Glow -->
    <div
      class="footer-ambient-glow"
      aria-hidden="true"
    />

    <div class="footer-inner-wrapper">
      <!-- Section 1: Center-Aligned Brand Identity Cards -->
      <div class="footer-brand-pills">
        <a
          href="https://member.jciindia.in"
          target="_blank"
          rel="noopener noreferrer"
          class="brand-pill"
        >
          <div class="pill-icon-box">
            <v-icon
              small
              class="pill-icon"
            >mdi-shield-crown-outline</v-icon>
          </div>
          <div class="pill-text-group">
            <span class="pill-label">OFFICIAL PLATFORM</span>
            <span class="pill-name">
              JCI India
              <v-icon
                small
                class="external-icon"
              >mdi-open-in-new</v-icon>
            </span>
          </div>
        </a>

        <div
          class="pill-divider-dot"
          aria-hidden="true"
        />

        <a
          href="http://vaagai.org.in"
          target="_blank"
          rel="noopener noreferrer"
          class="brand-pill"
        >
          <div class="pill-icon-box">
            <v-icon
              small
              class="pill-icon"
            >mdi-lightning-bolt-outline</v-icon>
          </div>
          <div class="pill-text-group">
            <span class="pill-label">TECHNOLOGY PARTNER</span>
            <span class="pill-name">
              Powered by Vaagai Tecknowledge
              <v-icon
                small
                class="external-icon"
              >mdi-open-in-new</v-icon>
            </span>
          </div>
        </a>
      </div>

      <!-- Section 2: Center-Aligned Live System Status Indicator -->
      <div class="footer-status-center">
        <div class="system-status-badge">
          <span class="status-pulse-dot" />
          <span class="system-label">SYSTEM ACTIVE</span>
          <span class="version-pill">App v{{ AppVersion }}</span>
          <template v-if="VersionInfo">
            <span class="version-dot">•</span>
            <span class="version-detail">{{ VersionInfo }}</span>
          </template>
        </div>
      </div>

      <!-- Section 3: Elegant Center Glowing Separator -->
      <div
        class="footer-center-separator"
        aria-hidden="true"
      >
        <span class="separator-line" />
        <span class="separator-node" />
        <span class="separator-line" />
      </div>

      <!-- Section 4: Center-Aligned Copyright Row -->
      <div class="footer-copyright-center">
        <div class="copyright-text">
          &copy; {{ CurrentYear }} <span class="highlight">JCI India</span>. All
          Rights Reserved.
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { version } from "/package.json";
import common from "@/Common.vue";
// import ScrollToTop from "@/components/ScrollToTop.vue";

export default {
  name: "KTFooter",
  components: {
    // ScrollToTop,
  },
  mixins: [common],
  data() {
    return {
      AppVersion: version,
      VersionInfo: "",
      CurrentYear: new Date().getFullYear(),
    };
  },
  beforeMount() {
    console.log("beforeMount called");
    var url2 = "api/pages/version-info";
    var condition2 = {
      UserInterface: 9,
    };
    this.getPageDetails("VersionInfo", "", url2, condition2);
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@500;600;700;800&display=swap");

@keyframes auroraLightSweep {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes statusPulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 5px rgba(16, 185, 129, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
  }
}

@keyframes nodePulse {
  0%,
  100% {
    opacity: 0.6;
    box-shadow: 0 0 6px rgba(0, 87, 168, 0.4);
  }
  50% {
    opacity: 1;
    box-shadow: 0 0 12px rgba(0, 87, 168, 0.8);
  }
}

.executive-aurora-footer {
  position: relative;
  width: 100%;
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
  color: #0f172a;
  font-family: "Plus Jakarta Sans", "Inter", -apple-system, BlinkMacSystemFont,
    sans-serif;
  overflow: hidden;
  box-shadow: 0 -4px 20px rgba(15, 23, 42, 0.03);
  z-index: 10;
}

/* Top Accent Multi-Gradient Line */
.footer-top-accent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(
    90deg,
    #0057a8 0%,
    #0097d7 25%,
    #d97706 50%,
    #10b981 75%,
    #0057a8 100%
  );
  background-size: 200% 100%;
  animation: auroraLightSweep 8s linear infinite;
  z-index: 5;
}

.footer-ambient-glow {
  position: absolute;
  top: -50px;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  height: 200px;
  background: radial-gradient(
    circle,
    rgba(0, 87, 168, 0.05) 0%,
    rgba(255, 255, 255, 0) 70%
  );
  pointer-events: none;
  z-index: 1;
}

.footer-inner-wrapper {
  position: relative;
  z-index: 2;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 20px 18px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

/* ---------------- BRAND PILLS GRID (CENTERED) ---------------- */
.footer-brand-pills {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: 640px) {
    flex-direction: column;
    gap: 12px;
  }
}

.brand-pill {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  text-decoration: none;
  color: #0f172a;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.03);

  .pill-icon-box {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.25s ease;

    .pill-icon {
      color: #0057a8 !important;
      font-size: 18px !important;
      transition: transform 0.25s ease;
    }
  }

  .pill-text-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;

    .pill-label {
      font-size: 10px;
      font-weight: 800;
      letter-spacing: 0.8px;
      text-transform: uppercase;
      color: #64748b;
      line-height: 1.2;
    }

    .pill-name {
      font-size: 14px;
      font-weight: 700;
      color: #0f172a;
      display: flex;
      align-items: center;
      gap: 5px;
      line-height: 1.3;
      transition: color 0.25s ease;

      .external-icon {
        color: #94a3b8 !important;
        font-size: 14px !important;
        transition: transform 0.25s ease, color 0.25s ease;
      }
    }
  }

  &:hover {
    background: #ffffff;
    border-color: #93c5fd;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 87, 168, 0.1), 0 2px 6px rgba(0, 0, 0, 0.03);

    .pill-icon-box {
      background: #0057a8;
      border-color: #0057a8;

      .pill-icon {
        color: #ffffff !important;
        transform: scale(1.08);
      }
    }

    .pill-text-group {
      .pill-name {
        color: #0057a8;

        .external-icon {
          color: #0057a8 !important;
          transform: translate(2px, -2px);
        }
      }
    }
  }
}

.pill-divider-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #cbd5e1;

  @media (max-width: 640px) {
    display: none;
  }
}

/* ---------------- CENTERED SYSTEM STATUS ---------------- */
.footer-status-center {
  margin-top: 14px;
  display: flex;
  justify-content: center;
  width: 100%;
}

.system-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  border-radius: 20px;
  padding: 5px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  transition: all 0.25s ease;
  max-width: 90%;
  flex-wrap: wrap;
  justify-content: center;

  &:hover {
    background: #ffffff;
    border-color: #93c5fd;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.05);
    color: #0f172a;
  }

  .status-pulse-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #10b981;
    animation: statusPulse 2s infinite;
    flex-shrink: 0;
  }

  .system-label {
    font-size: 10.5px;
    font-weight: 800;
    letter-spacing: 0.8px;
    color: #0057a8;
    text-transform: uppercase;
  }

  .version-pill {
    color: #0f172a;
    font-weight: 700;
  }

  .version-dot {
    color: #94a3b8;
  }

  .version-detail {
    color: #475569;
    font-size: 12px;
    font-weight: 600;
  }
}

/* ---------------- CENTERED SEPARATOR ---------------- */
.footer-center-separator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 500px;
  margin: 16px 0 12px 0;
  gap: 12px;

  .separator-line {
    flex: 1;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(203, 213, 225, 0.8) 50%,
      transparent 100%
    );
  }

  .separator-node {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #0057a8;
    animation: nodePulse 3s infinite ease-in-out;
  }
}

/* ---------------- CENTERED COPYRIGHT ---------------- */
.footer-copyright-center {
  display: flex;
  justify-content: center;
  width: 100%;
}

.copyright-text {
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  letter-spacing: 0.1px;

  .highlight {
    color: #0f172a;
    font-weight: 800;
  }
}

/* Reduced Motion Support */
@media (prefers-reduced-motion: reduce) {
  .footer-top-accent,
  .status-pulse-dot,
  .separator-node {
    animation: none !important;
  }

  .brand-pill,
  .pill-icon,
  .external-icon {
    transition: none !important;
  }
}
</style>



